import React, { Component, Fragment } from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { withTranslation } from "react-i18next";
import * as Func from '../../../../helpers/functions';
import action from '../../../../actions/index';
import * as VoucherComponent from './component/CommonComponent';
import Model from '../../../../constants/Model';
import * as HMS from "../../common/component/Index";
import i18n from "../../../../constants/initLng";
import DEFINE, { VOUCHER } from "../../../../constants/Define";
import * as ANT from 'antd';
import queryString from "query-string";
import moment from 'moment'
import * as Config from '../../../../constants/Config';
import Wrapper from '../../common/component/Wrapper';
import EllipsisText from '../../common/component/EllipsisText';
import Voucher from '../../../../models/Voucher';
import { DATE_TIME_FORMAT } from "../../../../constants/Define";
import { toArray, find } from 'lodash';

let permisionActions = [];
class Vouchers extends Component {
    state = {
        titleTable: Func.getTitleTable(Model.VouchersModel.titleTable, ['action'], ['id', 'voucherType', 'usedCount']),
        modelVoucher: Object.getOwnPropertyNames(new Voucher()),
        viewResetPassword: false,
        componentTable: {
            checkCode: {
                width: 150,
                fixed: 'left',
                sorter: (i, k) => i.checkCode.length - k.length,
                key: 'checkCode',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                    <HMS.FilterDropdown
                        setSelectedKeys={setSelectedKeys}
                        selectedKeys={selectedKeys}
                        confirm={confirm}
                        clearFilters={clearFilters}
                    >
                    </HMS.FilterDropdown>
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
            },
            groupName: {
                width: 250,
                key: 'groupId',
                filterDropdown: ({ setSelectedKeys, selectedKeys, confirm }) => (
                    <HMS.SelectComponent
                        optionFilterProp="children"
                        className={`hms-form-control select-filter`}
                        value={selectedKeys[0]}
                        showSearch
                        hmsData={this.state.allGroups}
                        allowClear
                        onChange={e => {
                            setSelectedKeys(Func.getValueForm(e).value ? [Func.getValueForm(e).value] : []);
                            confirm();
                        }}
                    />
                ),
                filterIcon: filtered => (
                    <ANT.Icon type="filter" style={{ color: filtered ? '#1890ff' : undefined }} />
                ),
                render: (text, record) => <EllipsisText title={text} content={text} contentMaxWidth={230}
                    overlayClassName={'max-width-500'} overlayComponent={ANT.Tooltip} />
            },
            maxDiscountValue: {
                width: 150,
                align: 'right',
                render: (price, record) => Func.formatMoney(price),
            },
            minOrderValue: {
                width: 200,
                align: 'right',
                render: (price, record) => Func.formatMoney(price),
            },
            discountValue: {
                width: 100,
                sorter: (i, k) => i.discountValue.length - k.length,
                render: (text, record) => {
                    switch (record.voucherType) {
                        case DEFINE.GENERAL.VOUCHER_TYPE.GIFT:
                            return this.props.t(`item.group.${DEFINE.GENERAL.VOUCHER_TYPE.GIFT}`);
                        case DEFINE.GENERAL.VOUCHER_TYPE.PERCENT:
                            return `${text}%`;
                        case DEFINE.GENERAL.VOUCHER_TYPE.MONEY:
                            return `${Func.formatMoney(text.toString())}`;
                        default:
                            return "---";
                    }
                },
            },
            maxOrderValue: {
                width: 150,
                align: 'right',
                render: (price, record) => Func.formatMoney(price),
            },
            limitNumberOfTimes: {
                width: 150,
                align: 'right',
                render: (value, record) => `${record.usedCount}/${value}`
            },
            salePrice: {
                width: 150,
                sorter: (i, k) => i.salePrice.length - k.length,
                align: 'right',
                render: (price, record) => Func.formatMoney(price),
            },
            status: {
                key: 'status',
                render: (status, record) => {
                    const statusEnum = find(toArray(VOUCHER.STATUS), item => item.id === status)
                    return !!statusEnum && <Fragment>
                        <HMS.StatusComponent color={!record.isExpired ? statusEnum.color : 'grey'}
                            label={this.props.t(`item.voucher.statusVoucher.${statusEnum.key}`)} />
                        {record.isLocked && <ANT.Icon type="lock" style={{ color: VOUCHER.STATUS.LOCKED.color }} />}
                    </Fragment>
                },
                filters: toArray(VOUCHER.STATUS).map((item) => ({
                    value: item.id,
                    text: this.props.t(`item.voucher.statusVoucher.${item.key}`),
                })),
                filterMultiple: false,
            },
            fileUrl: {
                width: 200,
                render: (fileUrl) => <img src={`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${fileUrl}`} width="100%" />
            },
            isEnabled: {
                render: (isEnabled) => <HMS.StatusComponent color={isEnabled ? 'green' : 'red'}
                    label={isEnabled ? i18n.t('item.banner.active') : i18n.t('item.banner.deActive')} />
            },
            createdDate: {
                render: (date, record) => moment(moment.utc(date).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            propertyOfStay: {
                key: 'propertyOfStay',
                render: (text, record) => {
                    return text && text.name
                }
            },
            startDate: {
                render: (date, record) => date && moment(moment.utc(date).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            endDate: {
                render: (date, record) => date && moment(moment.utc(date).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            checkInDate: {
                render: (date, record) => date && moment(moment.utc(date).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            checkOutDate: {
                render: (date, record) => date && moment(moment.utc(date).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            checkedDate: {
                render: (date, record) => date && moment(moment.utc(date).toDate().toJSON()).format(DATE_TIME_FORMAT.SHORT_DATE),
            },
            action: {
                fixed: 'right',
                align: 'center',
                render: (text, record) => <VoucherComponent.EditComponent item={record} permisionActions={permisionActions}
                    onDeleteBanner={this.props.onDeleteBanner} />,
            }
        },
        vouchers: [],
        pageSize: this.props.vouchers.data.pageSize,
        pageIndex: this.props.vouchers.data.pageIndex,
        totalCount: this.props.vouchers.data.totalCount,
        totalPage: this.props.vouchers.data.totalPage,
        isFetching: false,
        isExport: false,
        filter: {},
        allGroups: [],

    };

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.VOUCHER);
        this.setState({
            pageSize: this.props.vouchers.data.pageSize,
            pageIndex: this.props.vouchers.data.pageIndex,
            totalCount: this.props.vouchers.data.totalCount,
            totalPage: Math.ceil(parseInt(this.props.vouchers.data.totalCount) / parseInt(this.props.vouchers.data.pageSize))
        })
        this.props.onListAllGroups();
        this.props.onListVoucher({ pageSize: this.props.vouchers.data.pageSize, pageIndex: this.props.vouchers.data.pageIndex });
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            isFetching: nextProps.vouchers.isFetching,
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.groups !== prevProps.groups) {
            let newData = Func.customOptionSelectHMS(this.props.groups.allGroups, ['name', 'id']);
            this.setState({ allGroups: newData })
        }
        if (this.props.vouchers.data !== prevProps.vouchers.data) {
            this.setState({
                vouchers: this.props.vouchers.data.result,
                pageSize: this.props.vouchers.data.pageSize,
                pageIndex: this.props.vouchers.data.pageIndex,
                totalCount: this.props.vouchers.data.totalCount,
                totalPage: Math.ceil(parseInt(this.props.vouchers.data.totalCount) / parseInt(this.props.vouchers.data.pageSize))
            })
        }
    }

    onClickDownloadExcel = (e) => {
        const filter = this.state.filter;
        filter.pageIndex = filter.pageIndex || this.state.pageIndex;
        filter.pageSize = filter.pageSize || this.state.pageSize;
        this.props.exportExcel(filter);
    }

    onChange = (pagination, filters, sorter) => {
        let filter = this.state.filter;
        if (filters.status) {
            switch (filters.status[0]) {
                case 998:
                    filters = Func.removeElementObject(filters, 'status');
                    filter = Func.removeElementObject(filter, 'status');
                    filter = Func.removeElementObject(filter, 'isExpired');
                    filters.IsLocked = true;
                    break;
                case 999:
                    filters = Func.removeElementObject(filters, 'status');
                    filter = Func.removeElementObject(filter, 'status');
                    filter = Func.removeElementObject(filter, 'IsLocked');
                    filters.isExpired = true;
                    break;
                default:
                    if (filters.status[0] !== 998) { filter = Func.removeElementObject(filter, 'IsLocked') }
                    if (filters.status[0] !== 999) { filter = Func.removeElementObject(filter, 'isExpired') }
            }
        }
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filter: newFilters
        });
        this.props.onListVoucher(newFilters);
    };

    render() {
        const { t } = this.props;
        const voucherState = this.props.vouchers;
        const { totalPage, titleTable, vouchers, modelVoucher, isFetching, totalCount, pageIndex, pageSize, componentTable, } = this.state;
        return (
            <Fragment>
                <HMS.PageListComponent>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'vouchers'}
                        titleHeader={t('navigation.vouchers')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <div>
                                    <Link to={`/vouchers/action`}
                                        className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                    <Link to={`/vouchers/import`}
                                        className='btn btn-primary ml-3'>+ {t(`item.voucher.importExcel`)}</Link>
                                    <ANT.Button className='btn btn-primary ml-3' disabled={voucherState.isFetchingDownload}
                                        onClick={this.onClickDownloadExcel}>
                                        <ANT.Icon type={voucherState.isFetchingDownload ? 'loading' : 'download'} className="mr-1" />{t(`item.voucher.exportFileExcel`)}
                                    </ANT.Button>
                                    <a href={VOUCHER.TEMPLATE_FILE_URL}
                                        className='btn btn-warning ml-3'>{t(`item.voucher.exportExcel`)}</a>
                                </div>
                            }
                            </Fragment>
                        }
                    />
                    <HMS.ListComponent
                        tableKey="voucher-list"
                        scroll={{ x: 2800 }}
                        rowKey={record => record.id}
                        loading={{ spinning: isFetching, size: 'large' }}
                        dataSource={Func.getDataSource(vouchers, modelVoucher)}
                        columns={Func.columnsTable({
                            titleTable: titleTable,
                            component: componentTable,
                            itemName: 'voucher'
                        })}
                        onChange={this.onChange}
                        pagination={{ total: totalCount, totalPage: totalPage, current: pageIndex, pageSize }}
                        componentTableList={{
                            // right: <Fragment>{
                            //     permisionActions && permisionActions.allowCreate &&
                            //     <div>
                            //         <Link to={`/vouchers/action`}
                            //             className='btn btn-primary'>+ {t(`action.create`)}</Link>
                            //         <Link to={`/vouchers/import`}
                            //             className='btn btn-primary ml-3'>+ {t(`item.voucher.importExcel`)}</Link>
                            //         <a href={VOUCHER.TEMPLATE_FILE_URL}
                            //             className='btn btn-warning ml-3'>{t(`item.voucher.exportExcel`)}</a>
                            //     </div>
                            // }
                            // </Fragment>
                        }}
                        classChildren="p-0" classParent="m-0"
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        vouchers: state.voucherReducer,
        groups: state.groupReducer
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        onListVoucher: (filters) => {
            dispatch(action.dataVoucherAction(filters))
        },
        onListAllGroups: (filters) => {
            dispatch(action.dataAllGroupAction(filters))
        },
        exportExcel: params => dispatch(action.exportExcelVoucher(params))
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Vouchers));
